import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Bar, mixins } from 'vue-chartjs';
import { IRealtimeStat } from '../../interfaces/IRealtimeStat';
import { round2 } from '../../utils';

@Component({
  extends: Bar, // this is important to add the functionality to your component
  mixins: [mixins.reactiveProp],
})
export default class StackedBarChart extends Vue<Bar> {
  @Prop() chartData;
  firstTime = true;

  mounted() {
    this.draw();
  }

  @Watch('chartData')
  onDataChanged() {
    this.draw();
  }

  draw() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    let maxVal = 0;
    for (let i = 0; i < this.chartData.datasets[0].data.length; i++) {
      let val = 0;
      for (const data of this.chartData.datasets) {
        val += data.data[i];
      }
      if (val > maxVal) maxVal = val;
    }

    let max = 0,
      stepSize = 0;

    if (maxVal === 0) {
      max = 10;
      stepSize = 5;
    } else if (maxVal < 10) {
      max = Math.ceil(maxVal / 2) * 2;
      stepSize = max / 2;
    } else if (maxVal < 100) {
      max = Math.ceil(maxVal / 10) * 10;
      stepSize = max / 5;
    } else {
      max = Math.ceil(maxVal / 100) * 100;
      stepSize = max / 5;
    }

    let total = 0;

    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      animation: {
        duration: this.firstTime ? 1000 : 0,
      },
      tooltips: {
        mode: 'index',
        intersect: false,
        callbacks: {
          afterTitle: () => {
            total = 0;
          },
          label: (tooltipItem, data) => {
            const corporation = data.datasets[tooltipItem.datasetIndex].label;
            const valor =
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            total += valor;
            return corporation + ': ' + valor;
          },
          footer: () => {
            return 'Total: ' + round2(total);
          },
        },
      },
      hover: {
        mode: 'nearest',
        intersect: true,
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
            ticks: {
              beginAtZero: true,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            position: 'right',
            gridLines: {
              display: true,
            },
            ticks: {
              stepSize: max / 2,
              beginAtZero: true,
              max,
            },
          },
        ],
      },
    });

    this.firstTime = false;
  }
}
